var _g, _g2, _rect, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _circle, _circle2, _g3, _path4, _path5, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 584,
    viewBox: "0 0 651 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13_36499)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 97.0693,
    width: 515.116,
    height: 663.02,
    rx: 40.4812,
    transform: "rotate(-9.95709 11 97.0693)",
    fill: "#F6F4F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_13_36499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.9607 85.3143C70.9607 62.9571 89.0848 44.833 111.442 44.833L545.595 44.833C567.952 44.833 586.076 62.9571 586.076 85.3142L586.076 667.372C586.076 689.729 567.952 707.853 545.595 707.853L111.442 707.853C89.0847 707.853 70.9607 689.729 70.9607 667.372L70.9607 85.3143Z",
    fill: "#FCFAF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.404,
    y: 128.031,
    width: 188.706,
    height: 68.8521,
    rx: 10.1203,
    fill: "#E3E7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.228 351.053C121.228 345.464 125.759 340.933 131.348 340.933L526.04 340.933C531.629 340.933 536.16 345.464 536.16 351.053V492.738C536.16 498.327 531.629 502.858 526.04 502.858L131.348 502.858C125.759 502.858 121.228 498.327 121.228 492.738L121.228 351.053Z",
    fill: "#EBE9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.424 437.065V429.995L287.25 397.091H293.146V407.156H289.551L275.531 429.372V429.756H304.601V437.065H266.424ZM289.839 446.172V434.908L289.934 431.745V397.091H298.322V446.172H289.839ZM328.15 447.107C324.204 447.107 320.817 446.108 317.989 444.111C315.177 442.098 313.012 439.198 311.494 435.411C309.993 431.609 309.242 427.032 309.242 421.679C309.258 416.327 310.017 411.774 311.518 408.019C313.036 404.248 315.201 401.373 318.013 399.392C320.841 397.41 324.22 396.42 328.15 396.42C332.081 396.42 335.46 397.41 338.288 399.392C341.116 401.373 343.281 404.248 344.782 408.019C346.3 411.79 347.059 416.343 347.059 421.679C347.059 427.048 346.3 431.633 344.782 435.435C343.281 439.222 341.116 442.114 338.288 444.111C335.476 446.108 332.097 447.107 328.15 447.107ZM328.15 439.605C331.218 439.605 333.638 438.096 335.412 435.076C337.201 432.04 338.096 427.575 338.096 421.679C338.096 417.781 337.689 414.506 336.874 411.853C336.059 409.201 334.909 407.204 333.423 405.862C331.937 404.504 330.179 403.825 328.15 403.825C325.099 403.825 322.686 405.343 320.913 408.379C319.139 411.398 318.245 415.832 318.229 421.679C318.213 425.594 318.604 428.885 319.403 431.553C320.218 434.221 321.368 436.234 322.854 437.592C324.34 438.934 326.105 439.605 328.15 439.605ZM351.885 437.065V429.995L372.711 397.091H378.607V407.156H375.012L360.992 429.372V429.756H390.062V437.065H351.885ZM375.299 446.172V434.908L375.395 431.745V397.091H383.783V446.172H375.299Z",
    fill: "#B0B7C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.115 492.366C455.115 486.777 459.646 482.246 465.235 482.246H525.957C531.546 482.246 536.077 486.777 536.077 492.366V529.474C536.077 535.063 531.546 539.594 525.957 539.594H465.235C459.646 539.594 455.115 535.063 455.115 529.474V492.366Z",
    fill: "#EBE9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.762,
    y: 252.851,
    width: 188.706,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.762,
    y: 279.838,
    width: 131.564,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 350.53,
    y: 252.851,
    width: 57.3484,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 455.107,
    y: 252.851,
    width: 80.9624,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 350.53,
    y: 279.838,
    width: 40.4812,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 455.107,
    y: 279.838,
    width: 60.7218,
    height: 13.4937,
    rx: 6.74687,
    fill: "#E3E7EE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 91.9836,
    y: 65.3633,
    width: 473.53,
    height: 164.217,
    rx: 27.658,
    fill: "#D0D7E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_36499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 118,
    width: 480,
    height: 112
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7341,
    y: 118.228,
    width: 479.154,
    height: 111.353,
    rx: 27.658,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_36499)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 329.839,
    cy: 304.598,
    r: 177.118,
    fill: "#3158F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13_36499",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 127,
    width: 355,
    height: 355
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 329.839,
    cy: 304.6,
    r: 177.118,
    fill: "#3158F2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13_36499)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.712 138.681C364.416 135.903 378.462 132.893 385.022 131.735C412.419 138.681 470.687 173.642 484.578 257.917C460.268 257.917 471.844 282.227 469.529 294.961C464.065 325.016 449.464 304.994 444.061 291.488C441.746 274.124 429.707 259.075 418.593 263.705C407.48 268.336 388.495 261.776 380.392 257.917C373.832 256.374 362.564 255.37 369.973 263.705C377.382 272.04 388.495 275.668 393.126 276.439C411.262 279.912 412.805 290.331 388.495 297.277C333.231 313.066 327.141 256.76 328.298 247.498C329.224 240.09 311.705 232.835 302.83 230.134C286.623 219.715 297.042 210.454 302.83 208.139C309.098 205.632 323.668 211.612 328.298 203.508C332.003 197.026 327.526 193.862 324.825 193.09C320.581 191.932 308.387 193.09 293.569 206.981C275.047 224.346 256.525 201.193 255.367 200.036C254.21 198.878 250.737 194.247 244.949 195.405C240.318 196.331 234.53 195.791 232.215 195.405C226.427 194.247 227.584 188.459 231.057 184.986C234.331 181.712 249.193 177.269 256.525 175.725C265.4 175.339 285.697 171.095 295.884 157.203C306.072 143.312 324.825 139.067 332.929 138.681C340.646 139.839 357.007 141.459 360.712 138.681Z",
    fill: "#0E38DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.585 196.561C191.69 195.635 179.73 209.295 175.486 216.241C171.782 218.093 171.628 222.415 172.014 224.344C173.866 228.975 178.188 226.273 180.117 224.344C181.275 221.643 186.831 216.935 199.797 219.713C212.762 222.492 217.547 216.241 218.319 212.768C219.864 207.751 219.48 197.487 205.585 196.561Z",
    fill: "#0E38DC"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.132 60.5057C288.695 70.0685 294.067 83.0385 294.067 96.5623C294.067 110.086 288.695 123.056 279.132 132.619L251.572 160.179C246.88 164.871 239.272 164.871 234.579 160.179L207.019 132.619C197.456 123.056 192.084 110.086 192.084 96.5621C192.084 83.0382 197.456 70.0683 207.019 60.5054C216.582 50.9426 229.552 45.5703 243.076 45.5703C256.6 45.5703 269.57 50.9428 279.132 60.5057Z",
    fill: "#2D374B",
    stroke: "#2D374B",
    strokeWidth: 9.57392,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.074 98.0634C223.074 87.0178 232.029 78.0635 243.074 78.0635C254.12 78.0635 263.074 87.0178 263.074 98.0634C263.074 109.109 254.12 118.063 243.074 118.063C232.029 118.063 223.074 109.109 223.074 98.0634Z",
    fill: "#FCFAF9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 247.93,
    cy: 187.584,
    rx: 24.9986,
    ry: 9.04204,
    fill: "#2D374B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13_36499",
    x: 0.515885,
    y: 0.889563,
    width: 649.715,
    height: 769.818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.37343,
    dy: 6.74687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_36499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_36499",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_13_36499",
    x: 57.467,
    y: 31.3393,
    width: 555.597,
    height: 703.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.74687,
    dy: 6.74687
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.1203
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13_36499"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13_36499",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.545aa4be071021120f48eb510ac80317.svg";
export { ForwardRef as ReactComponent };